<div class="section mt-0">
  <h4>{{'menu.invoicing'|translate}}</h4>
  <dashboard-invoicing-summary [data]="summary"></dashboard-invoicing-summary>
  <dashboard-invoicing-deviations [deviations]="deviations"></dashboard-invoicing-deviations>

  <dashboard-invoicing-list [invoices]="list"></dashboard-invoicing-list>
</div>
